Vendd.Scripts.load(function () {
    'use strict';

    Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetSessionState());

    if (LhApp.Context.Item.Template.indexOf('productDetails') >= 0) {
        Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, 'session.js', function (envelope) {
            trackStats();
            trackAffiliates();
        });
    }
    else {
        Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, 'session.js', function (envelope) {
            trackStats();
            trackAffiliates();
        });
    }

    var trackStatsCompleted;
    function trackStats() {
        //just tracking. allow some delay.
        window.setTimeout(function () {
            if (trackStatsCompleted)
                return;
            trackStatsCompleted = true;

            Vendd.HandleItemStatistics();
            Vendd.HandleProductStatistics();
        }, 1000);
    }

    var trackAffiliatesCompleted;
    function trackAffiliates() {
        //page trackiing disbaled
        if (!LhApp.Context.IsAffiliateTrackingEnabled)
            return;

        //just tracking. allow some delay.
        window.setTimeout(function () {
            if (trackAffiliatesCompleted)
                return;

            if (LhApp.Context.IsConsentsEnabled) {
                if (window.ConsentsManager.cookiesStatus.marketingCookies) {
                    trackAffiliatesCompleted = true;
                    LhApp.Function.PageTrackingRequest();
                }
            } else {
                trackAffiliatesCompleted = true;
                LhApp.Function.PageTrackingRequest();
            }
        }, 1000);
    }

    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, 'session.js.InsertAllCookiesSuccess', function () {
        trackAffiliates();
    });
});